module.exports = __webpack_public_path__ + "img/摄图网_501104919_banner_青少年教育（非企业商用） (1).db46b73c.png";